module.exports = __webpack_public_path__ + "img/page.8140308b.png";